import clsx from "clsx";

const statusStyles: Record<string, string> = {
  sent: "bg-purple-100 text-purple-700",
  active: "bg-teal-light text-teal",
  scheduled: "bg-amber-100 text-amber-700",
  draft: "bg-gray-100 text-gray-500",
  published: "bg-emerald-100 text-emerald-700",
  archived: "bg-slate/10 text-slate",
  sending: "bg-blue-100 text-blue-700",
  throttled: "bg-amber-100 text-amber-700",
  paused: "bg-orange-100 text-orange-700",
  unsubscribed: "bg-red-100 text-red-600",
  bounced: "bg-red-100 text-red-600",
};

export default function StatusBadge({ status }: { status: string }) {
  return (
    <span
      className={clsx(
        "inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold capitalize",
        statusStyles[status] || "bg-gray-100 text-gray-500"
      )}
    >
      {status}
    </span>
  );
}
